import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DatenauswertungBWL } from './DatenauswertungBWL';
import { DatenauswertungCO2Fussabdruck } from './DatenauswertungCO2Fussabdruck';
import { DatenauswertungCO2FussabdruckDetails } from './DatenauswertungCO2FussabdruckDetails';
import { DatenauswertungEnergiekennzahlenEmmission } from './DatenauswertungEnergiekennzahlenEmmission';
import { DatenauswertungEnergiekennzahlenKostenbezogen } from './DatenauswertungEnergiekennzahlenKostenbezogen';
import { DatenauswertungEnergiekennzahlenSpez } from './DatenauswertungEnergiekennzahlenSpez';
import { DatenauswertungEnergiekennzahlenVerbrauchsbezogen } from './DatenauswertungEnergiekennzahlenVerbrauchsbezogen';
import { DatenauswertungEnergietraegerGesamt } from './DatenauswertungEnergietraegerGesamt';
import { DatenauswertungEnergietraegerNeu } from './DatenauswertungEnergietraegerNeu';
import { DatenauswertungFahrzeuge } from './DatenauswertungFahrzeuge';
import { DatenauswertungKraftstoffe } from './DatenauswertungKraftstoffe';
import { DatenauswertungMaschinenUndAnlagen } from './DatenauswertungMaschinenUndAnlagen';
import { DatenauswertungReportKonfiguration } from './DatenauswertungReportKonfiguration';
import { DatenauswertungReportSitemap } from './DatenauswertungReportSitemap';
import { DatenauswertungReportText } from './DatenauswertungReportText';
import { DatenauswertungStromNeu } from './DatenauswertungStromNeu';
import { DatenauswertungWasser } from './DatenauswertungWasser';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { disableKosten } from '../../helpers/showKosten';
import { Document, Image, Page } from '@react-pdf/renderer';
import { EnergieCockpit } from './EnergieCockpit2';
import { getGewerk } from '../../main/functions/getGewerk';
import { hasKennzahlenSpez } from './speziell/getKennziffernSpeziell';
import { IDs } from '../../helpers/IDs';
import { isValid } from '../../main/functions/validData';
import { lazyInject } from '../../services/inversify';
import { pdf } from '@react-pdf/renderer';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { ZusatztoolsEntwicklungsfahrplan } from '../zusatztools/ZusatztoolsEntwicklungsfahrplan';
import { WActionButton } from '../../core/elements/WActionButton';

interface DatenauswertungReportProps extends React.ClassAttributes<any> {
    data: any;
    jahrFirst?: number;
    jahrLast?: number;
    routing: any;
    standort?: number;
    onRoutingChange: (routing: any) => void;
}

interface DatenauswertungReportState {
    checkDone: boolean;
    jahrFirst: number;
    jahrLast: number;
    message: string;
    renderIndex: number;
    blacklist: number[];
    pages: any[];
    showConfig: boolean;
    pdfPreviewData?: string;
}

export class DatenauswertungReport extends React.Component<DatenauswertungReportProps, DatenauswertungReportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            checkDone: false,
            jahrFirst: this.props.jahrFirst,
            jahrLast: this.props.jahrLast,
            message: null,
            renderIndex: -1,
            blacklist: null,
            pages: null,
            showConfig: false
        };
        this.benchmarkingKennzahl1 = this.contextService.get('benchmarkingKennzahl1');
        this.benchmarkingKennzahl2 = this.contextService.get('benchmarkingKennzahl2');
        this.check = this.check.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    private parts: JSX.Element[] = [];
    private jsx: JSX.Element[] = [];
    private seen: any = {};
    private pages: any[];
    private benchmarkingKennzahl1: string;
    private benchmarkingKennzahl2: string;
    private disableKosten: boolean;
    private hasEntwicklungsfahrplan: boolean;

    componentDidMount(): void {
        this.disableKosten = disableKosten(this.props.data);
        SectionStyle.curPrintSectionId = 1;
        this.dataService.loadData(IDs.ENT_MASSNAHMEN, {}, {}, (result: any) => {
            this.hasEntwicklungsfahrplan = ((result || {})[IDs.ENT_MASSNAHMEN] || []).length > 0;
            this.check();
        }, IDs.MOD_ETOOL);
    }

    componentWillUnmount(): void {
        SectionStyle.curPrintSectionId = null;
    }

    addBWL(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungBWL
                key={id}
                data={this.props.data}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addCO2Fussabdruck(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungCO2Fussabdruck
                key={id}
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addCO2FussabdruckDetails(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungCO2FussabdruckDetails
                key={id}
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                jahr={this.getLastDataYear(this.state.jahrLast)}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addEnergieCockpit(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        // this.contextService.set(`benchmarkingKennzahl1`, 'energiekosten_ma');
        // this.contextService.set(`benchmarkingKennzahl2`, 'energiekosten_umsatz');
        this.parts.push(
            <EnergieCockpit
                key={id}
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
                standortName={standort.name}
                standortTid={standort.tid}
                jahr={this.getLastDataYear(this.state.jahrLast)}
            />
        );
    }

    addEnergiekennzahlen(standort: any, index: number, key: string): void {
        const hasKosten = !this.disableKosten && hasKennzahlenSpez(this.props.data, 'kosten', standort.tid);
        const hasVerbrauch = hasKennzahlenSpez(this.props.data, 'verbrauch', standort.tid);
        if (!this.disableKosten) {
            const id: string = `${key}-allg_kosten-${index}`;
            const page: number = this.setPage(
                'Energiekennzahlen', standort, key, { key: 'allg_kosten', name: 'Allg. Energiekennzahlen (kostenbezogen)' }
            );
            this.parts.push(
                <DatenauswertungEnergiekennzahlenKostenbezogen
                    key={id}
                    data={this.props.data}
                    standortTid={standort.tid}
                    standortName={standort.name}
                    onRoutingChange={this.props.onRoutingChange}
                    setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                    callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
                    jahrFirst={this.state.jahrFirst}
                    jahrLast={this.state.jahrLast}
                />
            );
        }
        const id2: string = `${key}-allg_verbrauch-${index}`;
        const page2: number = this.setPage(
            'Energiekennzahlen', standort, key, { key: 'allg_verbrauch', name: 'Allg. Energiekennzahlen (verbrauchsbezogen)' }
        );
        this.parts.push(
            <DatenauswertungEnergiekennzahlenVerbrauchsbezogen
                key={id2}
                data={this.props.data}
                standortTid={standort.tid}
                standortName={standort.name}
                onRoutingChange={this.props.onRoutingChange}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id2, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page2)}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
            />
        );
        if (hasKosten) {
            const id3: string = `${key}-spez_kosten-${index}`;
            const page3: number = this.setPage(
                'Energiekennzahlen', standort, key, { key: 'spez_kosten', name: 'Spez. Kennzahlen (kostenbezogen)' }
            );
            this.parts.push(
                <DatenauswertungEnergiekennzahlenSpez
                    key={id3}
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortTid={standort.tid}
                    standortName={standort.name}
                    mode='kosten'
                    setJSXdirect={(content: JSX.Element) => this.setJSX(id3, content)}
                    callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page3)}
                    jahrFirst={this.state.jahrFirst}
                    jahrLast={this.state.jahrLast}
                />
            );
        }
        if (hasVerbrauch) {
            const id4: string = `${key}-spez_verbrauch-${index}`;
            const page4: number = this.setPage(
                'Energiekennzahlen', standort, key, { key: 'spez_verbrauch', name: 'Spez. Kennzahlen (verbrauchsbezogen)' }
            );
            this.parts.push(
                <DatenauswertungEnergiekennzahlenSpez
                    key={id4}
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortTid={standort.tid}
                    standortName={standort.name}
                    mode='verbrauch'
                    setJSXdirect={(content: JSX.Element) => this.setJSX(id4, content)}
                    callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page4)}
                    jahrFirst={this.state.jahrFirst}
                    jahrLast={this.state.jahrLast}
                />
            );
        }
        const id5: string = `${key}-emissionen-${index}`;
        const page5: number = this.setPage(
            'Energiekennzahlen', standort, key, { key: 'emissionen', name: 'Emissionen (CO₂)' }
        );
        this.parts.push(
            <DatenauswertungEnergiekennzahlenEmmission
                key={id5}
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id5, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page5)}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
            />
        );
    }

    addEntwicklungsfahrplan(key: string, page: number): void {
        this.parts.push(
            <ZusatztoolsEntwicklungsfahrplan
                key={key}
                data={this.props.data}
                setJSXdirect={(content: JSX.Element) => this.setJSX(key, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addFahrzeuge(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungFahrzeuge
                key={id}
                data={this.props.data}
                jahr={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addKraftStoffe(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungKraftstoffe
                key={id}
                data={this.props.data}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addMaschinen(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungMaschinenUndAnlagen
                key={id}
                data={this.props.data}
                jahr={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addStrom(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungStromNeu
                key={id}
                data={this.props.data}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    addWaerme(standort: any, index: number, key: string): void {
        const data: any = this.props.data || {};
        const energietraegerWaerme: any[] = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER] || [];
        const energiedaten: any[] = (data[IDs.ENT_ENERGIEDATEN_WAERME] || [])
            .filter((item: any) => !standort.tid || item.standort_tid_orig === standort.tid)
            .filter((element: any, idx: any, array: any) => (
                element.energietraeger_tid_orig
                && (!standort.tid || element.standort_tid_orig === standort.tid)
                && array.map((item: any) => item.energietraeger_tid_orig).indexOf(element.energietraeger_tid_orig) === idx
                && (!(element.monat || 0) && isValid(element, IDs.ENT_ENERGIEDATEN_WAERME, data))
            ))
            .map((item: any) => item.energietraeger_tid_orig);
        const gesamt: string[] = [];
        energietraegerWaerme.forEach((item: any) => energiedaten.indexOf(item.tid) !== -1 ? gesamt.push(item) : null);
        const energietraeger: any[] = [{ name: 'Gesamt', gesamt }, ...energietraegerWaerme];
        console.log('ET PDF: ', energietraeger);
        energietraeger.forEach((item: any) => {
            const disabled: boolean = item.gesamt
                ? gesamt.length < 2
                : energiedaten.indexOf(item.tid || null) === -1;
            const id: string = `${key}-${item.id || 'gesamt'}-${index}`;
            const values: string[] = [...(item.id ? [item.id] : (item.gesamt || []).map((item2: any) => item2.id))];

            if (disabled) {
                return;
            }
            const page: number = this.setPage('Wärme', standort, 'waerme', { key: item.id || 'gesamt', name: item.name || null });
            this.parts.push(
                <DatenauswertungEnergietraegerGesamt
                    key={id}
                    data={this.props.data}
                    jahrFirst={this.state.jahrFirst}
                    jahrLast={this.state.jahrLast}
                    energietraeger={values}
                    // energietraeger={item.id || null}
                    onRoutingChange={this.props.onRoutingChange}
                    routing={this.props.routing}
                    standortTid={standort.tid}
                    standortName={standort.name}
                    setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                    callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
                />
            );
        });
    }

    addWasser(standort: any, index: number, key: string, page: number): void {
        const id: string = `${key}-${index}`;
        this.parts.push(
            <DatenauswertungWasser
                key={id}
                data={this.props.data}
                jahrFirst={this.state.jahrFirst}
                jahrLast={this.state.jahrLast}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortTid={standort.tid}
                standortName={standort.name}
                setJSXdirect={(content: JSX.Element) => this.setJSX(id, content)}
                callbackPages={(pageNumber: number) => this.setCurPage(pageNumber, page)}
            />
        );
    }

    check(): void {
        const startCheck = new Date().getTime();
        const data: any = this.props.data || {};
        const gewerk = getGewerk(data);
        const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];
        // const disabledErneuerbareEnergien: boolean = !konfiguration
        //    .some((param: any) => param.daten_erneuerbare_energien_orig === 1);
        const disabledFahrzeuge: boolean = !gewerk || !konfiguration
            .some((param: any) => param.daten_fahrzeuge_orig === 1);
        const disabledMaschinen: boolean = !gewerk || !konfiguration
            .some((param: any) => param.daten_maschinen_orig === 1);
        const standorte: any[] = (data[IDs.ENT_STANDORT] || [])
            .filter((item: any) => this.props.standort ? item.tid === this.props.standort : true)
            .filter((item2: any) => (+item2.energiedaten_erfassen_orig || +item2.energiedaten_erfassen || 0) === 1)
            .sort((a: any, b: any) =>
                (+((+a.standort_typ_tid_orig || 0) !== 1) - +((+b.standort_typ_tid_orig || 0) !== 1)) || (a.name > b.name)
            );
        const startjahr: number = (konfiguration
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        let cntDataStandorte = 0;
        this.jsx = [];
        this.pages = [];
        this.parts = [];
        this.seen = {};

        if (standorte.length > 1) { // Gesamtunternehmen macht nur bei mehreren Standorten sinn.
            standorte.push({ tid: 0, name: 'Gesamtunternehmen' });
        }

        standorte.forEach((standort: any, index: number) => {
            if (standort.tid === 0 && cntDataStandorte < 2) {
                return;
            }
            const kennzahlen: any = standort.tid
                ? (data[IDs.KENNZIFFERN_BERECHNET_STANDORT][standort.tid] || {}) || {}
                : data[IDs.KENNZIFFERN_BERECHNET] || {};
            const flags: any = kennzahlen.flags || {};
            const disabledFahrzeugeJahr: boolean = !(!disabledFahrzeuge && (data[IDs.ENT_FAHRZEUGE] || []).some((fahrzeug: any) =>
                (standort.tid === 0 || standort.tid === fahrzeug.standort_tid_orig)
                && (
                    (fahrzeug.status || null) !== 2
                    || (
                        (fahrzeug.status || null) === 2 && typeof fahrzeug.jahr_status === 'number' && this.state.jahrLast >= startjahr
                        && fahrzeug.jahr_status >= this.state.jahrLast
                    )
                )
                && isValid(fahrzeug, IDs.ENT_FAHRZEUGE)
            ));
            const disabledMaschinenJahr: boolean = !(!disabledMaschinen && (data[IDs.ENT_MASCHINEN] || []).some((maschine: any) =>
                (standort.tid === 0 || standort.tid === maschine.standort_tid_orig)
                && (
                    (maschine.status || null) !== 2
                    || (
                        (maschine.status || null) === 2 && typeof maschine.jahr_status === 'number' && this.state.jahrLast >= startjahr
                        && maschine.jahr_status >= this.state.jahrLast
                    )
                )
                && isValid(maschine, IDs.ENT_MASCHINEN)
            ));
            const hasData: boolean = flags.hasStrom || flags.hasWaerme || flags.hasKraftstoffe || flags.hasWasser || flags.hasBetriebsdaten
                || (flags.hasMaschinen && !disabledMaschinenJahr) || (flags.hasFahrzeuge && !disabledFahrzeugeJahr)
                || (flags.hasCO2);
            const showEnergieCockpit: boolean = flags.hasStrom || flags.hasWaerme || flags.hasKraftstoffe || (flags.hasCO2);
            let key: string = null;
            cntDataStandorte += hasData ? 1 : 0;
            if (showEnergieCockpit) {
                key = 'energiecockpit';
                this.addEnergieCockpit(standort, index, key, this.setPage('Energie-Cockpit', standort, key));
            }
            if (flags.hasStrom) {
                key = 'strom';
                this.addStrom(standort, index, key, this.setPage('Strom', standort, key));
            }
            if (flags.hasWaerme) {
                key = 'waerme';
                this.addWaerme(standort, index, key);
            }
            if (flags.hasKraftstoffe) {
                key = 'kraftstoffe';
                this.addKraftStoffe(standort, index, key, this.setPage('Kraftstoffe', standort, key));
            }
            if (flags.hasWasser) {
                key = 'wasser';
                this.addWasser(standort, index, key, this.setPage('Wasser', standort, key));
            }
            if (flags.hasBetriebsdaten) {
                key = 'betriebsdaten';
                this.addBWL(standort, index, key, this.setPage('Betriebsdaten', standort, key));
            }
            if (flags.hasKraftstoffe || flags.hasWaerme || flags.hasStrom) {
                key = 'energiekennzahlen';
                this.addEnergiekennzahlen(standort, index, key);
            }
            if (flags.hasMaschinen && !disabledMaschinenJahr) {
                key = 'maschinen';
                this.addMaschinen(standort, index, key, this.setPage('Maschinen / Anlagen / Heizung', standort, key));
            }
            if (flags.hasFahrzeuge && !disabledFahrzeugeJahr) {
                key = 'fahrzeuge';
                this.addFahrzeuge(standort, index, key, this.setPage('Fahrzeuge', standort, key));
            }
            if (flags.hasCO2) {
                key = 'co2';
                this.addCO2Fussabdruck(standort, index, key, this.setPage('CO₂-Fußabdruck', standort, key));
                key = 'co2_details';
                this.addCO2FussabdruckDetails(standort, index, key, this.setPage('CO₂-Fußabdruck Jahresauswertung', standort, key));
            }
        });

        if (this.hasEntwicklungsfahrplan) {
            const key: string = 'entwicklungsfahrplan';
            this.addEntwicklungsfahrplan(key, this.setPage('Entwicklungsfahrplan', null, key));
        }
        console.log('Check rendering done: ', (new Date().getTime() - startCheck));
        this.setState({ checkDone: true, pages: this.pages });
    }

    async finish(prepare?: boolean): Promise<void> {
        const deckblatt = require('../../img/Deckblatt_2026.jpg');
        const deckblatt_back = require('../../img/Deckblatt_2023_back.jpg');
        const imageUnternehmen = this.contextService.get('UNTERNEHMEN_LOGO_URL');
        const pdfData: JSX.Element = (
            <Document>
                <Page size='A4' orientation='portrait' style={{ padding: 0 }}>
                    <Image src={deckblatt} />
                    {imageUnternehmen &&
                        <Image src={imageUnternehmen} style={{ width: 'auto', height: 60, top: 45, right: 36, position: 'absolute' }} />
                    }
                </Page>
                {this.renderSitemap()}
                <DatenauswertungReportText isPdf />
                {this.jsx.map((page: JSX.Element, index: number) =>
                    <React.Fragment key={`page-${index}`}>{page}</React.Fragment>
                )}
                <Page size='A4' orientation='portrait' style={{ padding: 0 }}>
                    <Image src={deckblatt_back} />
                </Page>
            </Document>
        );
        const reset = () => {
            this.setState({ renderIndex: -1, checkDone: false, message: null }); // RenderIndex zurücksetzen
            this.jsx = [];
            this.parts = [];
            this.seen = {};
        };

        if (prepare) {
            this.contextService.set(`benchmarkingKennzahl1`, this.benchmarkingKennzahl1);
            this.contextService.set(`benchmarkingKennzahl2`, this.benchmarkingKennzahl2);
        }

        try {
            const start = new Date().getTime();
            console.log('Start rendering PDF ...');
            const blob = await pdf(pdfData).toBlob();
            // console.log('PDF-Blob done');
            console.log('Done rendering PDF ...', (new Date().getTime() - start));
            if (blob && prepare) {
                this.finish();
            }

            if (!prepare) {
                const pdfString = URL.createObjectURL(blob);
                const reader = new FileReader();
                reader.onloadend = (event: any) => this.setState({ pdfPreviewData: event.target.result });
                reader.readAsDataURL(blob);
                const filename = 'Auswertung_Report.pdf';
                // const a = document.createElement('a');
                // a.title = filename;
                // a.href = pdfString;
                // a.download = filename;
                // document.body.appendChild(a);
                // a.click();
                // document.body.removeChild(a);
                saveAs(pdfString, filename);
                reset();
            }
        } catch (error) {
            // console.log('error: ', error);
            reset();
        }
    }

    getLastDataYear(max: number): number {
        const data: any = this.props.data || {};
        const startjahr: number = this.state.jahrFirst
            || ((data[IDs.ENT_KONFIGURATION] || []).find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung
            || null;
        const min: number = +startjahr > 1900 ? startjahr : 2010;
        let jahr: number = null;

        if ((+max || 0) <= min) {
            return null;
        }

        for (let curJahr: number = max; curJahr >= min; --curJahr) {
            if (jahr) {
                break;
            }
            [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME].forEach((entity: string) => {
                if ((data[entity] || []).some((item: any) => (+item.jahr || null) === +curJahr && isValid(item, entity))) {
                    jahr = curJahr;
                }
            });
        }
        return jahr;
    }

    render(): JSX.Element {
        /*
        // Optimierungsversuch ....
        if (this.state.checkDone && this.state.renderIndex !== -1) {
            if (this.state.blacklist.indexOf(this.state.renderIndex) !== -1 ) {
                window.setTimeout(() =>  {
                    this.jsx.push(<></>);
                    if (this.jsx.length >= this.parts.length) {
                        this.setState({ message: 'PDF wird erzeugt ...' }, () => this.finish(true));
                    } else {
                        console.log(`PDF Next Render Index: ${this.state.renderIndex + 1}`);
                        this.setState({renderIndex: this.state.renderIndex + 1});
                    }
                }, 10);
                return <>
                    {this.state.showConfig && this.renderConfig()}
                </>;
            }
        }
        */
        const deckblatt = require('../../img/Deckblatt_2026.jpg');
        return (
            <div style={{ fontSize: '9pt', padding: 20 }}>
                <b style={{ fontSize: '10pt' }}>E-Tool REPORT - Bericht generieren:</b><br />
                <br />
                Mit dieser Funktion können Sie alle Ergebnistabellen aus dem Datenausgabebereich (inkl. "Energie-Cockpit") in einem Bericht
                zusammenstellen und als PDF herunterladen.
                <div style={{ marginTop: 15 }}>
                    {(this.state.checkDone && this.state.renderIndex !== -1)
                        ? <div>
                            {this.state.message
                                ? <b>{this.state.message}</b>
                                : <b>Seite {this.state.renderIndex + 1} wird vorbereitet ...</b>
                            }
                            <div style={{ overflow: 'hidden', height: 0, maxHeight: 0 }}>
                                {!this.state.message &&
                                    <div>
                                        {((this.state.blacklist || []).indexOf(this.state.renderIndex) === -1) &&
                                            this.parts[this.state.renderIndex]
                                        }
                                        {((this.state.blacklist || []).indexOf(this.state.renderIndex) !== -1) &&
                                            <>{setTimeout(() => this.setJSX(`skipped-${this.state.renderIndex}`, null))}</>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        : [this.renderPdfButton(), this.renderPdfConfigButton()]
                    }
                </div>
                {this.state.showConfig && this.renderConfig()}
                <img
                    style={{ marginTop: 10, width: 200, border: '1px solid #eee' }}
                    src={deckblatt}
                    alt='Deckblatt'
                />
                <div className="cont-datenauswertung" />
            </div>
        );
    }

    renderConfig(): JSX.Element {
        return (
            <DialogWrapper2
                onAfterClose={() => this.setState(
                    {
                        blacklist: null, checkDone: false, jahrFirst: this.props.jahrFirst,
                        jahrLast: this.props.jahrLast, pdfPreviewData: null, showConfig: false
                    },
                    this.check
                )}
                title='PDF-Report Konfiguration'
            >
                <DatenauswertungReportKonfiguration
                    data={this.props.data}
                    jahrFirst={this.state.jahrFirst}
                    jahrLast={this.state.jahrLast}
                    jahrMin={this.props.jahrFirst}
                    jahrMax={this.props.jahrLast}
                    onAction={(data: any) => {
                        if (!this.state.checkDone) {
                            this.check();
                        }
                        data = data || {};
                        this.setState({ blacklist: data.blacklist || [], renderIndex: 0 });
                    }}
                    onFirstJahrChange={(jahr: number) => this.setState({ checkDone: false, jahrFirst: +jahr }, this.check)}
                    onLastJahrChange={(jahr: number) => this.setState({ checkDone: false, jahrLast: +jahr }, this.check)}
                    pages={this.state.pages}
                    renderIndex={this.state.renderIndex}
                    pdfPreviewData={this.state.pdfPreviewData}
                    clearPdfPreview={() => this.setState({ pdfPreviewData: null })}
                />
            </DialogWrapper2>
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                styleProps={{ padding: '1px 8px', whiteSpace: 'nowrap' }}
                label='Vollständigen PDF-Report erstellen'
                insideText='Vollständigen PDF-Report erstellen'
                key='pdf'
                action='pdf'
                disabled={this.state.checkDone && this.state.renderIndex !== -1}
                onAction={() => {
                    if (!this.state.checkDone) {
                        this.check();
                    }
                    this.setState({ renderIndex: 0 });
                }}
            />
        );
    }

    renderPdfConfigButton(): JSX.Element {
        return (
            <WActionButton
                styleProps={{ padding: '1px 8px', whiteSpace: 'nowrap', width: 200 }}
                label='PDF-Report konfigurieren'
                insideText='PDF-Report konfigurieren'
                key='config'
                action='config'
                disabled={this.state.checkDone && this.state.renderIndex !== -1}
                onAction={() => this.setState({ showConfig: true })}
            />
        );
    }

    renderSitemap(): JSX.Element {
        const blacklist: number[] = this.state.blacklist || [];

        return (
            <DatenauswertungReportSitemap
                isPdf
                pages={(this.pages || []).filter((item: any) => blacklist.indexOf(item.page) === -1)}
            />
        );
    }

    setCurPage(page: number, index: number): void {
        const item: any = this.pages[index] || {};

        if (!item.curPage) {
            item.curPage = page;
        }
    }

    setJSX(key: string, content: JSX.Element): void {
        if (this.seen[key]) {
            return; // Einfach haben wir schon, das kann bei einem 2. Render passieren
        }
        const renderIndex = this.state.renderIndex + 1;
        this.seen[key] = true;
        this.jsx.push(content);
        console.log('PDF Progress:', key, `${this.jsx.length} - ${this.parts.length}`);
        if (this.jsx.length >= this.parts.length) {
            this.setState({ message: 'PDF wird erzeugt ...' }, () => this.finish(true));
        } else {
            console.log(`PDF Next Render Index: ${renderIndex}`);
            this.setState({ renderIndex });
        }
    }

    setPage(name: string, standort: any, key: string, sub?: any): number {
        const page: number = this.parts.length;
        this.pages.push({ page, key, name, standort, ...(sub && { sub }) });
        return this.parts.length;
    }
}
